<template>
  <v-text-field
      :error-messages="error"
      :label="translation(translationList.series_ci, 'Serie')"
      v-model="seriesCi"
      :rules="seriesCiValidationRules"
      name="series_ci"
      @input="onInput"
      variant="outlined"
      :tile="true"
      counter="2"
      type="text"
  >
  </v-text-field>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch, toRefs } from 'vue';
import { useTranslationStore, translation } from '~/plugins/store/translations';
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null,
    customerIndex: Number as () => number | null,
  },
  setup(props, { emit }) {
    const { modelValue, customerIndex } = toRefs(props);
    const seriesCi = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);


    watch(modelValue, (newValue) => {
      seriesCi.value = newValue;
    });

    watch(seriesCi, (newValue) => {
      const isValid = validateSeriesCi(newValue);
      emit('update:modelValue', newValue);
      if (customerIndex.value !== undefined) {
        emit('validation-customer-status', { field: `series_ci-${customerIndex.value}`, isValid });
      } else {
        emit('validation-customer-status', { field: `series_ci`, isValid });
      }
    });

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const seriesCiValidationRules = [
      (v: string) => !!v || translation(translationList.value.required, 'Acest câmp este obligatoriu'),
      (v: string) => (v && v.length === 2) || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
      (v: string) => /^[A-Za-z\s]+$/.test(v) || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
    ];

    function validateSeriesCi(value: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        const errors = seriesCiValidationRules
            .map(rule => rule(value))
            .filter(result => result !== true) as string[];
        if (errors && errors.length > 0) {
          error.value = errors;
          return false;
        }
      }
      return seriesCiValidationRules.every(rule => rule(value) === true);
    }

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = validateSeriesCi(seriesCi.value);
      if (customerIndex.value !== undefined) {
        emit('validation-customer-status', { field: `series_ci-${customerIndex.value}`, isValid });
      } else {
        emit('validation-customer-status', { field: `series_ci`, isValid });
      }

      // Listen for validate events
      window.addEventListener('validate-customer', handleValidationEvent);
      window.addEventListener('validate-travel', handleValidationEvent);

    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && (data.detail === `series_ci-${customerIndex.value}`
          || data.detail === `series_ci`)
          || data.detail === `series-${customerIndex.value}`
          || data.detail === `series`) {
        const isValid = validateSeriesCi(seriesCi.value, true);
        if (isValid) {
          emit('validation-customer-status', { field: data.detail, isValid });
        }
      }
    };

    return {
      seriesCi,
      seriesCiValidationRules,
      translationList,
      translation,
      onInput(event) {
        seriesCi.value = event.target.value ? event.target.value.toUpperCase() : null;
      },
      error
    };
  },
});
</script>
